// @flow
export { default } from './ProductTags';



// WEBPACK FOOTER //
// ./src/components/product/ProductTags/index.js